<template>
  <header>
    <h1>GitHub Community in Berlin 🇩🇪</h1>
  </header>
</template>

<style scoped>
header {
  padding: 10px 20px;
  background-color: #42b983;
  color: #ffffff;
}
h1 {
  font-size: 1.25rem;
}
</style>
